import { Input, Modal, Space, Button } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useFormik } from "formik";
import React, { use, useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Search from "../../assets/search.svg";
import Table from "../../common/Table";
import { NavWrap } from "../ShopForTyres";
import { useDispatch, useSelector } from "react-redux";
import { create_delegate_user, get_delegate_users, delete_delegate_user, update_delegate_user } from "../../actions/auth";
import { CreateDelegateUser, UpdateDelegateUser } from "../../actions/auth/Action";


const DelegateUserAndRoles = () => {
  const [delegateUsers, setDelegateUsers] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [isAct, setIsAct] = useState({});
  const [id, setId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const inputRef = useRef();
  const dispatch = useDispatch();
  const delegate_users = useSelector((state) => state.auth?.delegate_users?.data?.delegate_users?.customers || []);
  const user = useSelector((state) => state.auth?.user?.data?.user || {});
  const shipToCodes = useSelector((state) => state.auth?.delegate_users?.data?.ship_to_codes || []);  
  const stored = localStorage.getItem("delegate_detials");
  const parsed = JSON.parse(stored || "{}");
  const delegateId = parsed.delegate_details?.id;
  const debounceTimer = useRef();
  console.log("Delegate ID:", delegateId);
  const createRes = useSelector((state) => state.auth?.create_delegate_user);
  const updateRes = useSelector((state) => state.auth?.update_delegate_user);

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      permissions: [],
      manageDelegates: false,
      claimShipmentCode: [],
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("Name is required"),
      email: Yup.string().email("Enter valid email").required("Email is required")
    }),
    onSubmit: (vals) => {
      // Prepare payload for create_delegate_user
      const payload = {
        id: isAct?.id || undefined, // send id if editing, else undefined
        name: vals.name,
        email: vals.email,
        module_permissions: {
          new_order: {
            view: vals.permissions.includes("New Order_display"),
            full_access: vals.permissions.includes("New Order_write"),
          },
          my_orders: {
            view: vals.permissions.includes("My Orders_display"),
            full_access: vals.permissions.includes("My Orders_write"),
          },
          marketing: {
            view: vals.permissions.includes("Marketing_display"),
            full_access: vals.permissions.includes("Marketing_write"),
          },
          claims: {
            view: vals.permissions.includes("Claims_display"),
            full_access: vals.permissions.includes("Claims_write"),
            shipment_code: vals.claimShipmentCode || [], // send array
          },
          manage_delegates: vals.manageDelegates,
        },
      };
      if( isAct?.id) {
        //payload = isAct;
        dispatch(update_delegate_user(payload));
      } 
      else{
        dispatch(create_delegate_user(payload)); // Include id if editing
      }
      setTimeout(() => {
        dispatch(get_delegate_users({
        }));
      }, 800); 
      setModalVisible(false);
      setIsAct({});
      formik.resetForm();
    }
  });
    useEffect(() => {
      if (createRes?.success) {
        toast.success("Created delegate successfully.");
        dispatch({ type: CreateDelegateUser.RESET });
      } else if (createRes?.success === false) {
        const errorMsg =
          createRes.data?.errors?.[0] ||
          createRes.data?.message ||
          "Something went wrong!";
        toast.error(errorMsg);
        dispatch({ type: CreateDelegateUser.RESET });
      }
    }, [createRes, dispatch]);

    useEffect(() => {
      if (updateRes?.success) {
        toast.success("Updated delegate successfully.");
        dispatch({ type: UpdateDelegateUser.RESET });
      } else if (updateRes?.success === false) {
        const errorMsg =
          updateRes.data?.errors?.[0] ||
          updateRes.data?.message ||
          "Something went wrong!";
        toast.error(errorMsg);
        dispatch({ type: UpdateDelegateUser.RESET });
      }
  }, [updateRes, dispatch]);

  
  useEffect(() => {
    const hasPermission =
      formik.values.permissions.includes("Claims_display") ||
      formik.values.permissions.includes("Claims_write");

    // ✅ Reset dropdown if no permission
    if (!hasPermission) {
      formik.setFieldValue("claimShipmentCode", "");
    }
  }, [formik.values.permissions]); // runs whenever permissions change

  const filteredData = Array.isArray(delegate_users)
    ? delegate_users
        .filter(user => user.id !== delegateId)
        .sort((a, b) => a.name?.localeCompare(b.name))
    : [];

  const searchFilteredData = filteredData.filter(user => {
    if (!searchTerm.trim()) return true;
    const term = searchTerm.toLowerCase();
    return (
      user.name?.toLowerCase().includes(term) ||
      user.email?.toLowerCase().includes(term) ||
      user.mobile?.toLowerCase().includes(term)
    );
  });

  useEffect(() => {
    dispatch(
      get_delegate_users({
      })
    );
  }, []);

  const callEnable = (isEnable, id) => {
    setDelegateUsers((prev) =>
      prev.map((u) =>
        u.id === id ? { ...u, status: isEnable ? "inactive" : "active" } : u
      )
    );
    toast.success(isEnable ? "Disabled successfully." : "Enabled successfully.");
    setId("");
    setConfirm(false);
  };

      const callDelete = async (id) => {
        try {
         dispatch(delete_delegate_user({
          id,
        }));
            setTimeout(() => {
            dispatch(get_delegate_users({
            }));
          }, 800); 
          
          // Update UI only after success (assuming your action returns a Promise)
          setDelegateUsers((prev) => prev.filter((u) => u.id !== id));
          toast.success("Deleted successfully.");
          setIsAct({});
          setConfirm(false);
        } catch (error) {
          toast.error("Failed to delete delegate user.");
        }
      };


        const columns = [
          { header: "Name", accessor: "name", width: 20 },
          { header: "Email", accessor: "email", width: 20 },
          {
            header: "Permissions",
            accessor: "module_permissions",
            width: 40,
            cell: (rec) => {
              const perms = [];
              Object.entries(rec.module_permissions || {}).forEach(([module, values]) => {
                let modName = module.replace(/_/g, " "); // prettier name
                if (values.view) perms.push(`${modName} (view)`);
                if (values.full_access) perms.push(`${modName} (write)`);
                // Special case for claims shipment_code and city,zip code
                if (module === "claims" && Array.isArray(values.shipment_code) && values.shipment_code.length > 0) {
                  const pins = values.shipment_code
                    .map(code => {
                      const match = shipToCodes.find(item => item.kunn2 === code);
                      return match ? `${match.city}& pincode: ${match.zip}` : code;
                    })
                    .join(", ");
                  perms.push(`${modName} ${pins}`);
                }
              });
              return perms.join(", ") || "-";
            },
          },
          {
            header: "Status",
            accessor: "status",
            width: 20,
            cell: (rec) => {
              // Display the status text from API (e.g. 'active', 'pending')
              if (!rec.status) return "-";
              switch (rec.status.toLowerCase()) {
                case "pending":
                  return "Invitation Sent";
                case "active":
                  return "Active";
                default:
                  return rec.status.charAt(0).toUpperCase() + rec.status.slice(1);
              }
            },
          },
          {
            header: "Action",
            accessor: "id",
            width: 20,
            cell: (rec) => (
              <Space>
                <button
                  className="enable-btn icon"
                  onClick={() => {
                    setIsAct(rec);
                    const permissionsArr = [];

                    if (rec.module_permissions?.new_order?.view) permissionsArr.push("New Order_display");
                    if (rec.module_permissions?.new_order?.full_access) permissionsArr.push("New Order_write");

                    if (rec.module_permissions?.my_orders?.view) permissionsArr.push("My Orders_display");
                    if (rec.module_permissions?.my_orders?.full_access) permissionsArr.push("My Orders_write");

                    if (rec.module_permissions?.marketing?.view) permissionsArr.push("Marketing_display");
                    if (rec.module_permissions?.marketing?.full_access) permissionsArr.push("Marketing_write");

                    if (rec.module_permissions?.claims?.view) permissionsArr.push("Claims_display");
                    if (rec.module_permissions?.claims?.full_access) permissionsArr.push("Claims_write");

                    formik.setValues({
                      name: rec.name || "",
                      email: rec.email || "",
                      permissions: permissionsArr,
                      manageDelegates: rec.module_permissions?.manage_delegates || false,
                      claimShipmentCode: rec.module_permissions?.claims?.shipment_code || "",
                    });

                    setModalVisible(true);
                  }}
                >
                  <EditOutlined />
                </button>
                <button
                  className="enable-btn icon"
                  onClick={() => {
                    setIsAct(rec);
                    setConfirm(true);
                  }}
                >
                  <DeleteOutlined />
                </button>
              </Space>
            ),
          },
        ];
        
  return (
    <NavWrap>
      {/* Add / Edit Modal */}
        <Modal
        title="New Delegate User"
        visible={modalVisible}
        onCancel={() => {
          setModalVisible(false);
          formik.resetForm();
        }}
        footer={null}
      >
        <form onSubmit={formik.handleSubmit} className="marketing-form">
          <div className="mb1">
            <label>Name</label>
            <Input name="name" onChange={formik.handleChange} value={formik.values.name} />
            {formik.errors.name && <div className="error-text">{formik.errors.name}</div>}
          </div>

          <div className="mb1">
            <label>Email</label>
            <Input name="email" onChange={formik.handleChange} value={formik.values.email} />
            {formik.errors.email && <div className="error-text">{formik.errors.email}</div>}
          </div>
              <div className="mb1">
                <label>Permissions</label>
                <div style={{ border: "1px solid #d9d9d9", borderRadius: 4, padding: 12 }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: "left", padding: "8px" }}>Module</th>
                        <th style={{ textAlign: "center", padding: "8px" }}>Display</th>
                        <th style={{ textAlign: "center", padding: "8px" }}>Write</th>
                        <th style={{ textAlign: "center", padding: "8px" }}>Ship To Code</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        //{ module: "Dashboard", display: true, write: false },
                        { module: "New Order", display: true, write: true },
                        { module: "My Orders", display: true, write: true },
                        { module: "Marketing", display: true, write: false },
                        { module: "Claims", display: true, write: true, isClaims: true },
                      ].map(({ module, display, write, isClaims }) => (
                        <tr key={module}>
                          {/* Module Name */}
                          <td style={{ padding: "8px" }}>{module}</td>

                          {/* Display Checkbox */}
                          <td style={{ textAlign: "center" }}>
                            {display ? (
                              <input
                                type="checkbox"
                                checked={formik.values.permissions.includes(`${module}_display`)}
                                onChange={(e) => {
                                  const selected = formik.values.permissions;
                                  if (e.target.checked) {
                                    formik.setFieldValue("permissions", [...selected, `${module}_display`]);
                                  } else {
                                    formik.setFieldValue(
                                      "permissions",
                                      selected.filter((p) => p !== `${module}_display`)
                                    );
                                  }
                                }}
                              />
                            ) : (
                              <input type="checkbox" disabled />
                            )}
                          </td>

                          {/* Write Checkbox */}
                          <td style={{ textAlign: "center" }}>
                            {write ? (
                              <input
                                type="checkbox"
                                checked={formik.values.permissions.includes(`${module}_write`)}
                                onChange={(e) => {
                                  const selected = formik.values.permissions;
                                  if (e.target.checked) {
                                    formik.setFieldValue("permissions", [...selected, `${module}_write`]);
                                  } else {
                                    formik.setFieldValue(
                                      "permissions",
                                      selected.filter((p) => p !== `${module}_write`)
                                    );
                                  }
                                }}
                              />
                            ) : (
                              <input type="checkbox" disabled />
                            )}
                          </td>

                          {/* Shipment Code Dropdown (only for Claims) */}
                          <td style={{ textAlign: "center" }}>
                            {isClaims ? (
                                <>
                              <select
                                multiple
                                value={formik.values.claimShipmentCode}
                                onChange={(e) => {
                                  const selected = Array.from(e.target.selectedOptions, opt => opt.value);
                                  formik.setFieldValue("claimShipmentCode", selected);
                                }}
                                disabled={
                                  !(
                                    formik.values.permissions.includes("Claims_display") ||
                                    formik.values.permissions.includes("Claims_write")
                                  )
                                }
                                style={{
                                  padding: "4px",
                                  borderRadius: "4px",
                                  border: "1px solid #ccc",
                                  width: "100%",
                                  minHeight: "60px" // better UI for multi-select
                                }}
                              >
                                {shipToCodes.map(({ city, zip, kunn2 }) => (
                                  <option key={kunn2} value={kunn2}>
                                    {`${city},Pincode: ${zip}`} {/* Only show city + zip */}
                                  </option>
                                ))}
                              </select>
                            </>
                            ) : (
                              <input type="checkbox" disabled />
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div>
                  {formik.values.claimShipmentCode?.length > 0 && (
                      <div style={{ marginTop: "8px", display: "flex", flexWrap: "wrap", gap: "6px" }}>
                        {formik.values.claimShipmentCode.map((code) => {
                        const match = shipToCodes.find(item => item.kunn2 === code);
                        const cityZip = match ? `${match.city}, Pincode: ${match.zip}` : code;
                        return (
                          <span
                            key={code}
                            style={{
                              padding: "4px 8px",
                              background: "#f0f0f0",
                              borderRadius: "12px",
                              fontSize: "12px",
                            }}
                          >
                            {cityZip}
                          </span>
                        );
                      })}
                      </div>
                    )}
              </div>
              <div className="mb1" style={{ marginTop: "12px" }}>
                <label style={{ fontWeight: "500" }}>
                  Manage Delegates{" "}
                  <input
                    type="checkbox"
                    name="manageDelegates"
                    checked={formik.values.manageDelegates || false}
                    onChange={(e) =>
                      formik.setFieldValue("manageDelegates", e.target.checked)
                    }
                    style={{ marginLeft: "8px" }}
                  />
                </label>
                <div style={{ fontSize: "12px", color: "#1890ff", marginTop: "4px" }}>
                  <strong>Note:</strong> Allows managing other delegates.
                </div>
              </div>

          <div style={{ textAlign: "right" }}>
            <Button onClick={() => setModalVisible(false)} style={{ marginRight: "8px" }}>
            Cancel
            </Button>
            <Button type="primary" className="ml2 primary-btn" htmlType="submit">
            Save
            </Button>
          </div>
        </form>
      </Modal>

      {/* Confirm Modal */}
      <Modal
        footer={[
          <button key="close" className="cancel-btn mr1" onClick={() => setConfirm(false)}>
            Close
          </button>,
          <button
            key="confirm"
            className="primary-btn"
            onClick={() => {
              if (isAct?.id) {
                callDelete(isAct?.id);
              } else callEnable(true, id);
            }}
          >
            {isAct?.id ? "Delete" : "Disable"}
          </button>
        ]}
        title={"Are you sure you want to " + (isAct?.id ? "delete" : "disable") + " ?"}
        open={confirm}
        onCancel={() => setConfirm(false)}
      />

      {/* Search & Add */}
      {/* Title Row */}
          <div className="customers showTyresFilters admin">
        <div className="head">
          <h3>Delegates</h3>
        </div>
      {/* Search Bar & Add New */}
      <div className="flex-between mb2 table-head flex-between">
        <div className="input">
          <img src={Search} alt="search" />
          <input
            placeholder="Search by Name / Email / Mobile"
            onChange={(e) => {
              clearTimeout(debounceTimer.current);
              const val = e.target.value;
              debounceTimer.current = setTimeout(() => {
                setSearchTerm(val);
              }, 200);
            }}
          />
        </div>
        <button
          className="primary-btn"
          onClick={() => {
            setModalVisible(true);
          }}
        >
          + Add Delegate User
        </button>
      </div>

      {/* Table */}
      <Table
        loading={false}
        columns={columns}
        data={searchFilteredData}
      />
      </div>
    </NavWrap>
  );
};

export default DelegateUserAndRoles;